import { useQuery } from "@tanstack/react-query";
import { useIsApiReady } from "../hooks/use-api-ready";
import { kitFolderControllerGetFolder } from "../lib/gen-api";
import { queryKeys } from "../lib/query-keys";

export const useKitFolderData = ({
  kitUuid,
  folderUuid,
}: {
  kitUuid: string | null;
  folderUuid: string | null;
}) => {
  const { data, isLoading } = useQuery({
    enabled: useIsApiReady() && !!kitUuid && !!folderUuid,
    initialData: null,
    queryKey: queryKeys.kitsFolder({
      kitUuid: kitUuid!,
      folderUuid: folderUuid!,
    }),
    queryFn: () =>
      kitFolderControllerGetFolder({
        path: {
          kitUuid: kitUuid!,
          folderUuid: folderUuid!,
        },
      }).then((res) => res.data ?? null),
  });

  return {
    folder: data,
    isLoading,
  };
};
